import {ReferenceDTO} from './ReferenceDTO';
import {BaseDTO} from '../../../common/models/BaseDTO';

export class ApplicationReferenceLinkDTO extends BaseDTO {
  applicationId: number;
  reference: ReferenceDTO;
  startDate: Date;
  endDate: Date;
}
